(() => {
  function init(root) {
    if (root.dataset.directoryReady) return;
    root.dataset.directoryReady = 'true';
    const search = root.querySelector('[data-directory-search]');
    const empty = root.querySelector('[data-directory-empty]');
    const cards = [...root.querySelectorAll('[data-directory-card]')];
    const normalise = value => value.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    const original = new Map(cards.flatMap(card => [...card.querySelectorAll('details')].map(details => [details, details.open])));
    const text = new Map(cards.map(card => [card, normalise(card.textContent)]));
    search.addEventListener('input', () => {
      const terms = normalise(search.value).split(' ').filter(Boolean);
      let visible = 0;
      cards.forEach(card => {
        const matched = terms.every(term => text.get(card).includes(term));
        card.hidden = !matched;
        if (matched) visible++;
        card.querySelectorAll('details').forEach(details => {
          details.open = terms.length ? matched && terms.every(term => normalise(details.textContent).includes(term)) : original.get(details);
        });
      });
      empty.hidden = visible > 0;
    });
  }
  document.querySelectorAll('[data-collection-directory]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-collection-directory]').forEach(init));
})();
